export interface SmartIDLoginResponse {
    verificationCode: string;
}

export enum IdentityAuthResponseStatus {
    WAITING = 100,
    CANCELED = 101,
    OK = 102
}

export interface SmartIDVerificationResponse {
    state: IdentityAuthResponseStatus
}